import { Component } from "@angular/core";
import { LoaderService } from "../../base-services/loader.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: 'yt-loader',
    templateUrl: './loader.component.html'
})
export class YtLoader {

    constructor(protected loaderService: LoaderService){
    }

    private unsubscribe$ = new Subject<void>();
    
    ngOnInit(){
        this.loaderService.LoaderStatus
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(value => {
            this.showLoader = value;
        })
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
      }
    showLoader: boolean = false;
}